import { useEffect, useState } from "react";
import { api } from "../../api";
import { t } from "../../i18n";

export function OrganizationSwitcher({
  supportAccess = false,
}: {
  supportAccess?: boolean;
}) {
  const [state, setState] = useState<{
    activeOrganizationId: string;
    items: { id: string; name: string; role: string }[];
  }>();
  useEffect(() => {
    void api<typeof state>("/organizations")
      .then(setState)
      .catch(() => undefined);
  }, []);
  if (!state) return null;
  if (!supportAccess && state.items.length <= 1) return null;
  return (
    <div className="mb-3 px-2 text-xs text-stone-500 dark:text-stone-400">
      {supportAccess ? (
        <div className="mb-2 rounded-lg border border-amber-300/70 bg-amber-50 p-2 text-amber-900 dark:border-amber-500/30 dark:bg-amber-950/30 dark:text-amber-100">
          <div className="font-semibold">{t("Support access active")}</div>
          <div className="mt-1 leading-4">
            {t("This session has limited, time-bound customer access.")}
          </div>
          <button
            className="mt-2 text-xs font-medium underline"
            type="button"
            onClick={() => {
              void api("/site/support-access/deactivate", {
                method: "POST",
              }).then(() => window.location.reload());
            }}
          >
            {t("End support access")}
          </button>
        </div>
      ) : null}
      {state.items.length > 1 ? (
        <label className="block">
          <span className="mb-1 block font-semibold tracking-[.12em] uppercase">
            {t("Active organization")}
          </span>
          <select
            className="input w-full text-sm"
            value={state.activeOrganizationId}
            onChange={(event) => {
              void api(`/organizations/${event.target.value}/activate`, {
                method: "POST",
              }).then(() => window.location.reload());
            }}
          >
            {state.items.map((organization) => (
              <option key={organization.id} value={organization.id}>
                {organization.name} · {organization.role}
              </option>
            ))}
          </select>
        </label>
      ) : null}
    </div>
  );
}
